<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :maskStyle="{'top':'93px','left':'154px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:5%;height: 90%;">
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form :form="form" id="codeDictModal2">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典标签">
            <a-input placeholder="请输入字典标签" v-decorator.trim="[ 'dictLable', validatorRules.dictLable]"/>

          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典键值">
            <a-input placeholder="请输入字典键值" v-decorator.trim="[ 'dictValue', validatorRules.dictValue]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
            <a-select v-decorator.trim="[ 'status', validatorRules.status]">
              <a-select-option value="0">正常</a-select-option>
              <a-select-option value="1">停用</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
<!--      <function-tree-modal ref="functionTreeModal" @ok="functionTreeModalOk"></function-tree-modal>-->
    </a-modal>
  </div>
</template>

<script>
  function validateLength(rule, value, callback){
    callback(new Error('请输入长度为位的标签值'));

    if(tableDataSource.length>0){
      const L = this.tableDataSource[0].dictLable.length
      if(value.length == L){
        callback();
      }else{
        callback(new Error('请输入长度为'+L+'位的标签值'));
      }
    }else{
      callback()
    }

    // 请输入长度为{{}}位的标签值
    //
    // let params = {
    //   name: value,
    //   type: '会员',
    //   id: this.model.id?this.model.id:0
    // };
    // checkSupplier(params).then((res)=>{
    //   if(res && res.code===200) {
    //     if(!res.data.status){
    //       callback();
    //     } else {
    //       callback("会员卡号已经存在");
    //     }
    //   } else {
    //     callback(res.data);
    //   }
    // });
  }
  import pick from 'lodash.pick'
  import { addDict, editCodeDictData } from '@/api/identifierCode/identifierCode'
  import {autoJumpNextInput} from "@/utils/util"
  import { mixinDevice } from '@/utils/mixin'
  import {checkSupplier} from "@api/api";
  export default {
    name: 'CodeDictModal2',
    mixins: [ mixinDevice ],
    props: {
      tableDataSource:{},
      ruleId: { type: Array, required: true }
    },
    data() {
      return {
        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
          dictLable:{
            rules: [ { required: true, message: '请输入字典标签！' } ]
          },
          dictValue:{
            rules: [
              { required: true, message: '请输入字典键值！' }
            ]
          },
          status:{
            rules: [
              { required: true, message: '请选择状态！' }
            ]
          }
        }
      }
    },
    methods: {

      onChange(checked) {
        this.model.enabled = checked
      },
      add () {
        this.edit({});
        this.model.enabled = true
        this.enabledSwitch = true
      },
      edit (record) {
        console.log('这是嘛？')
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.enabled!=null){
          this.enabledSwitch = record.enabled?true:false;
        }
        if(this.model.uuid){
          this.jselectMultiple.value = record.pushBtn

          this.$nextTick(() => {
            this.form.setFieldsValue(pick( this.model, 'dictLable', 'dictValue', 'status' ))
            autoJumpNextInput('codeDictModal2')
          });
        } else {
          this.jselectMultiple.value = ''

          this.model = {
            status: '0',
          }
          this.$nextTick(() => {
            this.form.setFieldsValue(pick( this.model, 'dictLable', 'dictValue', 'status' ))
            autoJumpNextInput('codeDictModal2')
          })
        }

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            formData.pushBtn = this.jselectMultiple.value
            let obj;
            formData.dictId = this.ruleId

            if(this.tableDataSource.length >0){
              const L = this.tableDataSource[0].dictValue.length
              if(formData.dictValue.length != L){
                this.$message.warning('字典键值长度与其他字典不相同,请输入长度为'+L+'的字典名称')
                that.confirmLoading = false;
                return false
              }
            }


            if(!this.model.uuid){
              // 删除表单多余字段
              delete formData.enabled
              delete formData.pushBtn
              console.log('你执行吗？')
              addDict( formData ).then(res=>{
                if(res.code === 200){
                  that.$emit('ok');
                }else{
                  that.$message.warning(res.data.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
                that.close();
              })
            }else{
              editCodeDictData( formData ).then(res=>{
                if(res.code === 200){
                  that.$emit('ok');
                }else{
                  that.$message.warning(res.data.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
                that.close();
              })
            }

          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateNumber(rule, value, callback){
        let params = {
          number: value,
          id: this.model.id?this.model.id:0
        };
        checkNumber(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("编号已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      validateName(rule, value, callback){
        let params = {
          name: value,
          id: this.model.id?this.model.id:0
        };
        checkFunction(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("名称已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      onSearchParentNumber() {
        this.$refs.functionTreeModal.edit(this.model.id);
        this.$refs.functionTreeModal.title = "选择上级编号";
        this.$refs.functionTreeModal.disableSubmit = false;
      },
      functionTreeModalOk(number, name) {
        this.form.setFieldsValue({'parentNumber': number, 'parentName': name})
      }
    }
  }
</script>